export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  detail: (state) => state.detail,
  dilisense: (state) => state.dilisense,
  documents: (state) => state.documents,
  questionnaire: (state) => {
    try {
      return JSON.parse(state.questionnaire.questionnaire);
    }
    catch {
      return null;
    }
  },
  video: (state) => state.video,
};
